import React from 'react';
import CheckboxTable from "../../../../../common/CheckboxTable";
import {siteChargeOptions} from "../../../../../../services/ConstHelper";
import {t} from "../../../../../../services/i18n";

const UserChargeSetting = (props) => {
    const { values, setFieldValue, paymentProvider} = props;

    if(!paymentProvider) return null

    const isDisabled = (chargeType, platform) => {
        switch(platform) {
            case 'site':
                return chargeType !== 'bit' //only grow for now, will change later on to more complex condition
            default:
                return true;
        }
    }

    return (
        <CheckboxTable columns={['site']}
                       rows={siteChargeOptions[paymentProvider]} // I use this instead of Object.keys(values.properties) because it is sorted
                       mainColumnName={t('charge-option')}
                       isDisabled={isDisabled}
                       isChecked={(chargeType, platform) => !!values.properties?.[chargeType]?.site}
                       onChange={(chargeType, platform, checked) => setFieldValue(`properties.${chargeType}.site`, checked)}
        />
    );
};

export default UserChargeSetting;